export const formatNumber = (val: number) => {
  return new Intl.NumberFormat('en-US').format(Math.floor(val * 100) / 100)
}

export const formatNumber3Decimals = (val: number) => {
  return new Intl.NumberFormat('en-US').format(val)
}

export const formatNumber4Decimals = (val: number) => {
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 4,
    minimumFractionDigits: 0,
  }).format(val)
}

export const formatWordCapitalized = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1)
}
